import ManualOrderVariant from './ManualOrderVariant'

export default ManualOrderVariant
